import type { TNavKey } from "@/types";

export const DESKTOP_HEADER_NAV_KEYS: TNavKey[] = [
  "menu",
  "about",
  "selected",
  "search",
];

export const MOBILE_BOTTOM_NAV_KEYS: TNavKey[] = [
  "search",
  "menu",
  "selected",
  "scrollTop",
];

export const SIDEBAR_NAV_KEYS: TNavKey[] = ["menu", "selected", "about"];
